import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../helper/analytics";
import { trackRegistrationStepViewed } from "../../helper/registrationAnalytics";

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const previousPathnameRef = useRef(null);

  useEffect(() => {
    const { pathname } = location;

    if (previousPathnameRef.current === pathname) {
      return;
    }

    previousPathnameRef.current = pathname;
    trackPageView(pathname);
    trackRegistrationStepViewed(pathname);
  }, [location]);

  return null;
};

export default AnalyticsRouteTracker;
